import { VALIDATION_TYPE } from '@/vue/constants/validation-types';

const VGR_SHS_LENGTH = 12;
const IMEI_LENGTH = 15;
const EMAIL_REGEX = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9]*[a-zA-Z0-9])?$/;

export const CANNOT_CONTAIN_URL = {
    check: val => val.match(/((http:\/\/)|(https:\/\/))\S+/i) === null,
    message: 'form.cannot_contain_url',
    type: VALIDATION_TYPE.ERROR,
};

export const MAX_CHARACTERS = max => {
    return {
        check: val => val.length <= max,
        message: 'form.too_many_characters',
        type: VALIDATION_TYPE.ERROR,
    };
};

export const NOT_NEGATIVE_NUMBER = {
    check: val => +val >= 0,
    message: 'form.notNegative',
    type: VALIDATION_TYPE.ERROR,
};

export const CANT_BE_ZERO = {
    check: val => {
        const validVal = val !== undefined && val !== null && val !== '';
        return validVal ? +val !== 0 : true;
    },
    message: 'form.cantBeZero',
    type: VALIDATION_TYPE.ERROR,
};

export const BATTERY_COST_TOO_HIGH = currency => {
    return {
        check: val => {
            return currency === 'EUR' ? +val < 10 : true;
        },
        message: 'dynamicess.batteryCostWarning',
        type: VALIDATION_TYPE.ERROR,
    };
};

export const FIELD_IS_KWH = {
    check: val => +val < 1000,
    message: 'form.too_many_kwh',
    type: VALIDATION_TYPE.WARNING,
};

export const VALID_VRM_PORTAL_ID = {
    check: val => {
        return _.isString(val) && val.length >= VGR_SHS_LENGTH;
    },
    message: 'form.installationId',
    type: VALIDATION_TYPE.ERROR,
};

export const VALID_VRM_PORTAL_ID_IMEI = {
    check: val => {
        return _.isString(val) && val.length >= IMEI_LENGTH;
    },
    message: 'form.imei',
    type: VALIDATION_TYPE.ERROR,
};

export const VALID_EMAIL = {
    check: val => {
        return EMAIL_REGEX.test(val);
    },
    message: 'form.email',
    type: VALIDATION_TYPE.ERROR,
};

export const VALID_EMAIL_OR_EMPTY = {
    check: val => {
        return EMAIL_REGEX.test(val) || !val || (val && val.length == 0);
    },
    message: 'form.email',
    type: VALIDATION_TYPE.ERROR,
};
